import axios, { AxiosRequestConfig } from 'axios';

export const getCmsData = (config: AxiosRequestConfig) => {
    return axios(config)
        .then(res => ({ response: res.data, error: undefined }))
        .catch(err => ({ response: undefined, error: err }));
};
